/* Products section — staggered pop-in of the glass cards when the grid
   scrolls into view. Arming happens only when JS runs, so a script failure
   leaves the cards plainly visible instead of hidden. */

(function () {
  'use strict';

  if (customElements.get('orbis-products')) return;

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class OrbisProducts extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.orbis-products__grid');
      if (!this.grid) return;

      this.classList.add('orbis-products--ready');

      if (REDUCED_MOTION) {
        this.grid.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.grid.classList.add('is-visible');
            this.observer.disconnect();
          }
        });
      }, { rootMargin: '0px 0px -80px 0px' });
      this.observer.observe(this.grid);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('orbis-products', OrbisProducts);
})();
